import axios from "axios";

export const AUTH_URL = `/Auth`;
export const USER_URL = `/User`;

/** Belli Bir Okulun Bilgilerini Alan Adıyla Elde Eder */
export function getSchool(domain) {
  return axios.get(`${AUTH_URL}/${domain}`, { headers: { 'X-Ref-S': domain }});
}

/** Belli Bir Kullanıcının Giriş (Login) İşlemlerini Gerçekleştirir */
export function login(loginData) {
  return axios.post(AUTH_URL, loginData, { headers: { 'X-Ref-S': loginData.domain, 'X-Ref-U': loginData.authId }});
}

/** Belli Bir Kullanıcıya Yeniden Otp Kodu Gönderir */
export function resendOtpCode(loginData) {
  return axios.post(`${AUTH_URL}/ResendOtpCode`, loginData, { headers: { 'X-Ref-S': loginData.domain, 'X-Ref-U': loginData.authId }});
}

/** Belli Bir Kullanıcının Girmiş Olduğu Otp Kodunu Doğrular */
export function verifyOtpCode(loginData) {
  return axios.post(`${AUTH_URL}/VerifyOtpCode`, loginData, { headers: { 'X-Ref-S': loginData.domain, 'X-Ref-U': loginData.authId }});
}

/** Belli Bir Kullanıcının Mail Adresine Kullanıcı Bilgilerinin Yenileneceği Sayfanın Linkini Gönderir */
export function sendMail(loginData) {
  return axios.post(`${AUTH_URL}/SendMail`, loginData, { headers: { 'X-Ref-S': loginData.domain, 'X-Ref-U': loginData.authId }});
}

/** Belli Bir Şifre Belirleme İşlemine Ait Bilgileri Elde Eder */
export function getPasswordSetData(passwordData) {
  return axios.post(`${AUTH_URL}/GetPasswordSetData`, passwordData, { headers: { 'X-Ref-S': passwordData.domain, 'X-Ref-T': passwordData.token }});
}

/** Belli Bir Kullanıcının Kullanıcı Adı ve Şifresini Belirler */
export function setUsernameAndPassword(passwordData) {
  return axios.post(`${AUTH_URL}/SetUsernameAndPassword`, passwordData, { headers: { 'X-Ref-S': passwordData.domain, 'X-Ref-T': passwordData.token }});
}

/** Belli Bir Duyuru Gönderim İzinlerini Belirleme İşlemine Ait Bilgileri Elde Eder */
export function getNoticePermissionsData(permissionData) {
  return axios.post(`${AUTH_URL}/GetNoticePermissionsData`, permissionData, { headers: { 'X-Ref-S': permissionData.domain, 'X-Ref-U': permissionData.authId }});
}

/** Duyuru Yapılacak Belli Bir Kişiye Ait Duyuru Gönderim Türü İzinlerini Belirler */
export function setNoticePermissions(permissionData) {
  return axios.post(`${AUTH_URL}/SetNoticePermissions`, permissionData, { headers: { 'X-Ref-S': permissionData.domain, 'X-Ref-U': permissionData.authId }});
}

/** Belli Bir Oturuma (Session) Ait FCM (Firebase Console Manager) Token ını Günceller */
export function updateFCMToken(token) {
  return axios.post(`${USER_URL}/UpdateFCMToken`, { token });
}

/** Belli Bir Kullanıcının Çıkış (Logout) İşlemlerini Gerçekleştirir */
export function logout() {
  return axios.post(`${AUTH_URL}/Logout`);
}